/**
 * Modal for viewing bottle front/back images
 */

import { Modal, Button } from '../common';
import './BottleImageModal.css';

/**
 * Modal displaying bottle images
 * @param {Object} props - Component props
 * @param {boolean} props.isOpen - Whether modal is open
 * @param {Function} props.onClose - Close handler
 * @param {Object} props.bottle - Bottle data with image URLs
 * @returns {React.ReactElement|null} Modal element or null
 */
export default function BottleImageModal({ isOpen, onClose, bottle }) {
  if (!isOpen || !bottle) return null;

  const hasImages = bottle.image_front_url || bottle.image_back_url;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={bottle.bottle_name}
      size="lg"
      className="bottle-image-modal"
    >
      {hasImages ? (
        <div className="bottle-image-modal__content">
          {bottle.image_front_url && (
            <div className="bottle-image-modal__image-container">
              <span className="bottle-image-modal__label">Front Label</span>
              <img
                src={bottle.image_front_url}
                alt={`${bottle.bottle_name} front label`}
                className="bottle-image-modal__image"
              />
            </div>
          )}
          {bottle.image_back_url && (
            <div className="bottle-image-modal__image-container">
              <span className="bottle-image-modal__label">Back Label</span>
              <img
                src={bottle.image_back_url}
                alt={`${bottle.bottle_name} back label`}
                className="bottle-image-modal__image"
              />
            </div>
          )}
        </div>
      ) : (
        <div className="bottle-image-modal__empty">
          <svg className="bottle-image-modal__empty-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <circle cx="8.5" cy="8.5" r="1.5" />
            <path d="M21 15l-5-5L5 21" />
          </svg>
          <p className="bottle-image-modal__empty-text">No images available for this bottle</p>
        </div>
      )}
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
